/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection10FoiChanged, m11ReportSection10ResourceChanged, m11ResearchStudyResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection10Foi, selectM11ReportSection10Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { Button } from "semantic-ui-react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import BooleanEntry from "../../datatypeComponents/BooleanEntry";
import { StringKeyedEntry } from "../../datatypeComponents/StringEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveSecondaryObjectivesChanges = async (dispatch, apiToken, m11ResearchStudyFoi, secondaryObjectivesState,
  objectiveDictionaryState, narrativeDictionaryState, setAlertModalState,
  setStartingSecondaryObjectivesState, setStartingObjectiveDictionaryState, setStartingNarrativeDictionaryState) => {

  if (secondaryObjectivesState.notApplicable === true) {
    if (secondaryObjectivesState.objectivesArray.length > 0) {
      alert("This will delete secondary objectives content.")
    }
  }
  let changesStates = {
    secondaryObjectivesState: secondaryObjectivesState,
    objectiveDictionaryState: objectiveDictionaryState,
    narrativeDictionaryState: narrativeDictionaryState
  };
  let response = await saveM11Changes(apiToken, 10, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    let revisedObjectivesState = JSON.parse(JSON.stringify(secondaryObjectivesState));
    if (response.m11ResearchStudyResource) {
      dispatch(m11ResearchStudyResourceChanged(response.m11ResearchStudyResource));
      if (response.m11ResearchStudyResource.objective) {
        revisedObjectivesState.objectivesArray = response.m11ResearchStudyResource.objective;
        for (const objective of revisedObjectivesState.objectivesArray) {
          if (objective?.type?.coding?.[0]?.code === "secondary") {
            revisedObjectivesState.secondaryObjectivesArray.push(objective);
          }
        }
      }
    }
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection10Resource) {
      dispatch(m11ReportSection10ResourceChanged(response.m11ReportSection10Resource));
    }
    setStartingNarrativeDictionaryState(JSON.parse(JSON.stringify(narrativeDictionaryState)));
    setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(objectiveDictionaryState)));
    setStartingSecondaryObjectivesState(JSON.parse(JSON.stringify(revisedObjectivesState)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step010SecondaryObjectives = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection10Foi = useSelector(selectM11ReportSection10Foi);
  const m11ReportSection10Resource = useSelector(selectM11ReportSection10Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [secondaryObjectivesState, setSecondaryObjectivesState] = useState({
    "section105Heading": "",
    "section105Status": "empty", "section105Xhtml": "",
    "section105Section": [], "objectivesArray": [], "secondaryObjectivesArray": [],
    "notApplicable": false
  });
  const [startingSecondaryObjectivesState, setStartingSecondaryObjectivesState] = useState({
    "section105Heading": "",
    "section105Status": "empty", "section105Xhtml": "",
    "section105Section": [], "objectivesArray": [], "secondaryObjectivesArray": [],
    "notApplicable": false
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
  const [expandObjectiveState, setExpandObjectiveState] = useState({});
  const [objectiveDictionaryState, setObjectiveDictionaryState] = useState({});
  const [startingObjectiveDictionaryState, setStartingObjectiveDictionaryState] = useState({});
  const [narrativeDictionaryState, setNarrativeDictionaryState] = useState({
    "0": {
      "section10511Xhtml": "",
      "section10512Xhtml": "",
      "section10513Xhtml": "",
      "section10514Xhtml": "",
      "section10515Xhtml": ""
    }
  });
  const [startingNarrativeDictionaryState, setStartingNarrativeDictionaryState] = useState({
    "0": {
      "section10511Xhtml": "",
      "section10512Xhtml": "",
      "section10513Xhtml": "",
      "section10514Xhtml": "",
      "section10515Xhtml": ""
    }
  });
  const [unsavedChangesState, setUnsavedChangesState] = useState(false);
  const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

  useImperativeHandle(ref, () => ({
    unsavedChanges: unsavedChangesState === true,
    async saveAllChanges() {
      await saveSecondaryObjectivesChanges(dispatch, apiToken, m11ResearchStudyFoi, secondaryObjectivesState,
        objectiveDictionaryState, narrativeDictionaryState, setAlertModalState,
        setStartingSecondaryObjectivesState, setStartingObjectiveDictionaryState, setStartingNarrativeDictionaryState);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource) {
      if (!jsonEquals(secondaryObjectivesState, startingSecondaryObjectivesState) ||
        !jsonEquals(objectiveDictionaryState, startingObjectiveDictionaryState) ||
        !jsonEquals(narrativeDictionaryState, startingNarrativeDictionaryState)) {
        setUnsavedChangesState(true);
      } else {
        setUnsavedChangesState(false);
      }
    }
  }, [secondaryObjectivesState, startingSecondaryObjectivesState, objectiveDictionaryState,
    startingObjectiveDictionaryState, narrativeDictionaryState, startingNarrativeDictionaryState]);

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
      if (Array.isArray(m11ResearchStudyResource.contained) && m11ResearchStudyResource.contained.length > 0) {
        let containedResourceDictionary = {};
        for (const item of m11ResearchStudyResource.contained) {
          const key = "#" + item.id;
          containedResourceDictionary[key] = item;
        }
        setContainedResourceDictionary(containedResourceDictionary);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section105Heading": "",
        "section105Status": "empty", "section105Xhtml": "",
        "section105Section": [], "objectivesArray": [], "secondaryObjectivesArray": [],
        "notApplicable": false, "loaded": true
      };
      if (m11ResearchStudyResource.objective) {
        startingData.objectivesArray = JSON.parse(JSON.stringify(m11ResearchStudyResource.objective));
        for (const objective of startingData.objectivesArray) {
          if (objective?.type?.coding?.[0]?.code === "secondary") {
            startingData.secondaryObjectivesArray.push(JSON.parse(JSON.stringify(objective)));
          }
        }
      }
      if (startingData.secondaryObjectivesArray?.length > 0) {
        let startingSet = {};
        let startingDictionary = {};
        for (const index in startingData.secondaryObjectivesArray) {
          startingSet[index] = false;
          startingDictionary[index] = startingData.secondaryObjectivesArray[index];
        }
        setExpandObjectiveState(startingSet);
        setObjectiveDictionaryState(startingDictionary);
        setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
      } else {
        let startingSet = { "0": true };
        let startingDictionary = {
          "0": {
            "name": "",
            "description": "",
            "outcomeMeasure": []
          }
        };
        setExpandObjectiveState(startingSet);
        setObjectiveDictionaryState(startingDictionary);
        setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
      }
      setSecondaryObjectivesState(startingData);
      setStartingSecondaryObjectivesState(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[10]?.entry?.length) {
        let m11ReportSection010Foi = getIdFromReference(m11ReportContainerResource.section[10].entry[0]);
        if (m11ReportSection010Foi && !isNaN(m11ReportSection010Foi) && m11ReportSection010Foi !== m11ReportSection10Foi) {
          dispatch(m11ReportSection10FoiChanged(m11ReportSection010Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection10Foi && !isNaN(m11ReportSection10Foi)) {
      loadResource(m11ReportSection10Foi, "M11ReportSection10", apiToken, dispatch);
    }
  }, [m11ReportSection10Foi]);

  useEffect(() => {
    if (m11ReportSection10Resource && Object.keys(m11ReportSection10Resource).length > 0) {
      let startingData = {
        "section105Heading": "",
        "section105Status": "empty", "section105Xhtml": "",
        "section105Section": [], "objectivesArray": [], "secondaryObjectivesArray": [],
        "notApplicable": false, "loaded": true
      };
      if (m11ResearchStudyResource.objective) {
        startingData.objectivesArray = JSON.parse(JSON.stringify(m11ResearchStudyResource.objective));
        for (const objective of startingData.objectivesArray) {
          if (objective?.type?.coding?.[0]?.code === "secondary") {
            startingData.secondaryObjectivesArray.push(JSON.parse(JSON.stringify(objective)));
          }
        }
      }
      if (m11ReportSection10Resource.section?.[0]?.section?.[4]?.title) {
        startingData.section105Heading = m11ReportSection10Resource.section[0].section[4].title;
      }
      if (m11ReportSection10Resource.section?.[0]?.section?.[4]?.text) {
        startingData.section105Status = m11ReportSection10Resource.section[0].section[4].text.status;
        startingData.section105Xhtml = m11ReportSection10Resource.section[0].section[4].text.div;
      }
      if (startingData.section105Status !== "empty" &&
        (startingData.section105Xhtml === "<div xmlns=\"http://www.w3.org/1999/xhtml\">Not applicable.</div>" ||
          startingData.section105Xhtml === "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Not applicable.</p></div>")
      ) {
        startingData.notApplicable = true;
        setSecondaryObjectivesState(startingData);
        setStartingSecondaryObjectivesState(startingData);
      } else if (m11ReportSection10Resource.section?.[0]?.section?.[4]?.section?.length > 0) {
        startingData.section105Section = JSON.parse(JSON.stringify(m11ReportSection10Resource.section[0].section[4].section));
        if (startingData.secondaryObjectivesArray?.length > 0) {
          let startingSet = {};
          let startingDictionary = {};
          for (const index in startingData.secondaryObjectivesArray) {
            startingSet[index] = false;
            startingDictionary[index] = startingData.secondaryObjectivesArray[index];
          }
          setExpandObjectiveState(startingSet);
          setObjectiveDictionaryState(startingDictionary);
          setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
          if (startingData.section105Section?.length > 0) {
            let startingNarrativeDictionary = {};
            for (const index in startingData.section105Section) {
              let entry = {
                "section10511Xhtml": "",
                "section10512Xhtml": "",
                "section10513Xhtml": "",
                "section10514Xhtml": "",
                "section10515Xhtml": ""
              }
              if (startingData.section105Section[index]?.section?.length > 0) {
                if (startingData.section105Section[index].section[0]?.text?.div && startingData.section105Section[index].section[0].text.status !== "empty") {
                  entry.section10511Xhtml = startingData.section105Section[index].section[0].text.div;
                }
                if (startingData.section105Section[index].section[1]?.text?.div && startingData.section105Section[index].section[1].text.status !== "empty") {
                  entry.section10512Xhtml = startingData.section105Section[index].section[1].text.div;
                }
                if (startingData.section105Section[index].section[2]?.text?.div && startingData.section105Section[index].section[2].text.status !== "empty") {
                  entry.section10513Xhtml = startingData.section105Section[index].section[2].text.div;
                }
                if (startingData.section105Section[index].section[3]?.text?.div && startingData.section105Section[index].section[3].text.status !== "empty") {
                  entry.section10514Xhtml = startingData.section105Section[index].section[3].text.div;
                }
                if (startingData.section105Section[index].section[4]?.text?.div && startingData.section105Section[index].section[4].text.status !== "empty") {
                  entry.section10515Xhtml = startingData.section105Section[index].section[4].text.div;
                }
              }
              startingNarrativeDictionary[index] = entry;
            }
            setNarrativeDictionaryState(JSON.parse(JSON.stringify(startingNarrativeDictionary)));
            setStartingNarrativeDictionaryState(startingNarrativeDictionary);
          }
        }
        setSecondaryObjectivesState(startingData);
        setStartingSecondaryObjectivesState(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection10Resource]);

  return <div>
    <div className="h3Style h3EntryLabel" style={{ marginBottom: "0px" }}>
      Enter Secondary Objectives.<span> This will be used in Sections 1 (Protocol Summary), 3 (Objectives and Estimands) and 10 (Statistical Considerations).</span>
    </div>

    {!(m11ReportSection10Resource?.id || m11ReportContainerResource?.id) &&
      <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
    }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 10 (Enter Secondary Objectives) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>{
        secondaryObjectivesState.loaded &&
        <>
          <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
            <span>Set as </span>Not Applicable<span> if there are no secondary objectives.</span>
          </div>
          <BooleanEntry elementName='notApplicable'
            fieldLabel='Not Applicable' startingValue={secondaryObjectivesState.notApplicable}
            setResourceState={setSecondaryObjectivesState} />
          {secondaryObjectivesState.notApplicable === false &&
            <>
              {
                objectiveDictionaryState && Object.keys(objectiveDictionaryState).length > 0 &&
                Object.keys(objectiveDictionaryState).map((key, index) => {
                  let objective = objectiveDictionaryState[key];
                  return <div key={index}>
                    <h3>Secondary Objective {index + 1} {objective.name}  <button onClick={() => {
                      setExpandObjectiveState(prevState => { return { ...prevState, [index]: !expandObjectiveState[index] } });
                    }}>{expandObjectiveState[index] ? " ▼ collapse  " : " ► expand  "}</button></h3>
                    {expandObjectiveState[index] && <div>
                      {objective && <>
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Enter a name or short label for Secondary Objective {index + 1}.</span>
                        </div>
                        <StringKeyedEntry elementName='name'
                          required={true}
                          fieldLabel='Objective Name'
                          startingValue={objectiveDictionaryState[key].name}
                          index={index}
                          setKeyedResourceState={setObjectiveDictionaryState} />
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Enter a nontechnical (layperson) description for Secondary Objective {index + 1}.</span>
                        </div>
                        <StringKeyedEntry elementName='description'
                          fieldLabel='Objective Description'
                          startingValue={objectiveDictionaryState[key].description}
                          index={index}
                          setKeyedResourceState={setObjectiveDictionaryState} />
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Complete the Estimand Characteristics detail for each outcome and estimand for this objective. Click the </span>+Add Estimand<span> button to enter data for additional estimands.</span>
                        </div>
                        {!jsonEquals(objectiveDictionaryState[index], {
                          "name": "",
                          "description": "",
                          "outcomeMeasure": []
                        }) &&
                          <ArrayEntry datatype="M11Estimand" elementName='outcomeMeasure'
                            containedResourceDictionary={containedResourceDictionary}
                            doNotShowFieldLabel={true}
                            startCollapsed={true} startEmptyArrayClosed={false}
                            deletable={true} fieldLabel='Estimand'
                            startingValue={objectiveDictionaryState[key].outcomeMeasure || []}
                            index={index}
                            setKeyedResourceState={setObjectiveDictionaryState} />
                        }
                      </>}
                      <div className="h3Style h3EntryLabel" style={{ marginBottom: "0px" }}>
                        Complete Section 10.5.{index + 1} Secondary Objective {index + 1} (Statistical Considerations).
                      </div>
                      {narrativeDictionaryState[index] && <>
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Revise the </span>Section 10.5.{index + 1}.1 Statistical Analysis Method<span> as needed.</span>
                        </div>
                        <TextDivEntry elementName="section10511Xhtml"
                          startingValue={narrativeDictionaryState[index].section10511Xhtml}
                          index={index}
                          setKeyedResourceState={setNarrativeDictionaryState} />
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Revise the </span>Section 10.5.{index + 1}.2 Handling of Data in Relation to Secondary Estimand(s)<span> as needed.</span>
                        </div>
                        <TextDivEntry elementName="section10512Xhtml"
                          startingValue={narrativeDictionaryState[index].section10512Xhtml}
                          index={index}
                          setKeyedResourceState={setNarrativeDictionaryState} />
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Revise the </span>Section 10.5.{index + 1}.3 Handling of Missing Data in Relation to Secondary Estimand(s)<span> as needed.</span>
                        </div>
                        <TextDivEntry elementName="section10513Xhtml"
                          startingValue={narrativeDictionaryState[index].section10513Xhtml}
                          index={index}
                          setKeyedResourceState={setNarrativeDictionaryState} />
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Revise the </span>Section 10.5.{index + 1}.4 Sensitvity Analysis<span> as needed.</span>
                        </div>
                        <TextDivEntry elementName="section10514Xhtml"
                          startingValue={narrativeDictionaryState[index].section10514Xhtml}
                          index={index}
                          setKeyedResourceState={setNarrativeDictionaryState} />
                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                          <span>Revise the </span>Section 10.5.{index + 1}.5 Supplementary Analysis<span> as needed.</span>
                        </div>
                        <TextDivEntry elementName="section10515Xhtml"
                          startingValue={narrativeDictionaryState[index].section10515Xhtml}
                          index={index}
                          setKeyedResourceState={setNarrativeDictionaryState} />
                      </>}
                    </div>}
                  </div>
                })
              }
              <div style={{ marginBottom: "12px" }}>
                {(objectiveDictionaryState && secondaryObjectivesState.secondaryObjectivesArray) &&
                  <>
                    <Button className="formButton" style={{ color: "#000000" }}
                      content={"+ Add Secondary Objective"}
                      onClick={() => {
                        let newIndex = secondaryObjectivesState.secondaryObjectivesArray.length || 1;
                        setExpandObjectiveState(prevState => { return { ...prevState, [newIndex]: true } });
                        setObjectiveDictionaryState(prevState => {
                          return {
                            ...prevState,
                            [newIndex]: {
                              "name": "",
                              "description": "",
                              "outcomeMeasure": []
                            }
                          };
                        });
                        setNarrativeDictionaryState(prevState => {
                          return {
                            ...prevState,
                            [newIndex]: {
                              "section10511Xhtml": "",
                              "section10512Xhtml": "",
                              "section10513Xhtml": "",
                              "section10514Xhtml": "",
                              "section10515Xhtml": ""
                            }
                          };
                        });
                      }} />
                  </>}
              </div>
            </>}
        </>
      }</>
    }
  </div >
});

const M11Step010SecondaryObjectivesHelperText = <div>
  <h3>Enter Secondary Objectives</h3>
  <div style={{ textAlign: "left" }}>
    <p>Set as Not Applicable if there are no secondary objectives.</p>
    <p>Enter detail to add a secondary objective, or proceed to Step 11 if there are no (additional) secondary objectives to add, or proceed to Step 12 if there are no additional objectives to add.</p>
    <p>Enter a name or short label for the Secondary Objective. This will be used in the M11 Report Section 1 Protocol Summary.</p>
    <p>Enter a nontechnical (layperson) description for the Secondary Objective. If provided, this will be used in the M11 Report Section 1 Protocol Summary.</p>
    <p>Complete the Estimand Characteristics detail for each outcome and estimand for this objective. Click the +Add Estimand button to enter data for additional estimands.</p>
    <h3>Complete Section 10.5.X Secondary Objective X (Statistical Considerations)</h3>
    <div style={{ textAlign: "left" }}>
      <p>Enter data for Section 10.5.X.1 Statistical Analysis Method.</p>
      <div style={{ marginLeft: "24px" }} >
        <p>Clearly specify any secondary hypotheses that will be tested for confirmatory purposes.</p>
      </div>
      <p>Enter data for Section 10.5.X.2 Handling of Data in Relation to Secondary Estimand(s).</p>
      <div style={{ marginLeft: "24px" }} >
        <p>For each intercurrent event of the secondary estimand(s) defined in Section 3.1 Secondary Objective(s) and Associated Estimand(s), explain how data will be handled for the statistical analysis in line with the secondary estimand. The handling of intercurrent events in the statistical analysis should be aligned with the specific estimand strategies being used.</p>
        <p>This section should describe in more detail the rationale and handling of the data rather than repeating information from the preceding sections.</p>
      </div>
      <p>Enter data for Section 10.5.X.3 Handling of Missing Data in Relation to Secondary Estimand(s).</p>
      <div style={{ marginLeft: "24px" }} >
        <p>Describe how missing data will be addressed (e.g., imputation method and model), state the underlying assumptions, and provide a rationale for the approach.</p>
      </div>
      <p>If applicable, enter data for Section 10.5.X.4 Sensitivity Analysis.</p>
      <div style={{ marginLeft: "24px" }} >
        <p>Describe any sensitivity analyses and how their assumptions changed from the assumptions of the main statistical analysis. Sensitivity analyses are a series of analyses conducted with the intent to explore the robustness of inferences from the main estimator to deviations from its underlying modelling assumptions and limitations in the data.</p>
      </div>
      <p>If applicable, enter data for Section 10.5.X.5 Supplementary Analysis.</p>
      <div style={{ marginLeft: "24px" }} >
        <p>Describe any supplementary analysis, if applicable. Supplementary analyses are conducted in addition to the main and sensitivity analyses with the intent to provide additional insights into the understanding of the treatment effect.</p>
      </div>
      <p>Click the 'Save All Changes' button.</p>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>
// eslint-disable-next-line no-empty-pattern
const M11Step010SecondaryObjectivesValidationCheckk = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 10, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 10 (Enter Secondary Objectives) {validationCheckState.step10numberOfChecks} issues checked. {validationCheckState.step10numberPassed} passed. {validationCheckState.step10numberFailed} failed.</h4>
    <p>All secondary objectives have a description: {validationCheckState.resultCheckSecondaryObjectiveDescription}</p>
    <p>All secondary objectives have at least one associated estimand: {validationCheckState.resultCheckSecondaryObjectiveHasEstimand}</p>
    <p>Each estimand has an Endpoint description: {validationCheckState.resultCheckSecondaryEstimandHasEndpoint}</p>
    <p>Section 10.5 heading is 'Analyses Associated with the Secondary Objective(s)': {validationCheckState.resultCheckSection105Heading}</p>
    <p>Section 10.5 Analyses Associated with the Secondary Objective(s) has content of 'Not applicable' or subheadings: {validationCheckState.resultCheckSection105Content}</p>
    <p>If present, Section 10.5.X heading is 'Secondary Objective X' or 'Secondary Objective' if only one secondary objective: {validationCheckState.resultCheckSection105XHeading}</p>
    <p>If present, Section 10.5.X Secondary Objective X does not have text: {validationCheckState.resultCheckSection105XContent}</p>
    <p>If Section 10.5.X is present, Section 10.5.X.1 heading is 'Statistical Analysis Method': {validationCheckState.resultCheckSection105X1Heading}</p>
    <p>If Section 10.5.X is present, Section 10.5.X.1 Statistical Analysis Method has content: {validationCheckState.resultCheckSection105X1Content}</p>
    <p>If Section 10.5.X is present, Section 10.5.X.2 heading is 'Handling of Data in Relation to Secondary Estimand(s)': {validationCheckState.resultCheckSection105X2Heading}</p>
    <p>If Section 10.5.X is present, Section 10.5.X.2 Handling of Data in Relation to Secondary Estimand(s) has content: {validationCheckState.resultCheckSection105X2Content}</p>
    <p>If Section 10.5.X is present, Section 10.5.X.3 heading is 'Handling of Missing Data in Relation to Secondary Estimand(s)': {validationCheckState.resultCheckSection105X3Heading}</p>
    <p>If Section 10.5.X is present, Section 10.5.X.3 Handling of Missing Data in Relation to Secondary Estimand(s) has content: {validationCheckState.resultCheckSection105X3Content}</p>
    <p>If present, Section 10.5.X.4 heading is 'Sensitivity Analysis': {validationCheckState.resultCheckSection105X4Heading}</p>
    <p>If present, Section 10.5.X.4 Sensitivity Analysis has content: {validationCheckState.resultCheckSection105X4Content}</p>
    <p>If present, Section 10.5.X.5 heading is 'Supplementary Analysis': {validationCheckState.resultCheckSection105X5Heading}</p>
    <p>If present, Section 10.5.X.5 Supplementary Analysis has content: {validationCheckState.resultCheckSection105X5Content}</p>
  </div>}  </div>
}

export default M11Step010SecondaryObjectives;
export { M11Step010SecondaryObjectivesHelperText, M11Step010SecondaryObjectivesValidationCheckk };